import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./send-letter.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./send-letter.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { SendLetterConstants } from "./send-letter.constants";
import { FormControl, FormGroup } from "@angular/forms";
import { generateCsv, download } from "export-to-csv";
import { AlertType } from "../../models/alert";
import { AppControllerService } from "../../../app-controller.service";
import { SelectedApplicationService } from "../../services/selected-application/selected-application.service";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { SendLetterService } from "./service/send-letter.service";
import { StepService } from "../../../step/step.service";
import RecipientUtils from "../../utils/recipient-utils";
import { FileUtils } from "../../utils/file-utils";
import { LookupConstants } from "../../constants/lookup.constants";
import { WorkflowJobService } from "../../services/workflow-job/workflow-job.service";
import { CurrentStepService } from "../../services/current-step/current-step.service";
let SendLetterComponent = class SendLetterComponent {
    selectedApplicationService;
    sendLetterService;
    appControllerService;
    stepService;
    workflowJobService;
    currentStepService;
    changeDetectionRef;
    stepMeta;
    recipients;
    attachmentManagerAttachmentType;
    attachmentManagerTitle;
    attachmentManagerJobId;
    communicationType;
    moduleId;
    stepName;
    letterSent = new EventEmitter();
    sendLetterForm;
    letterTemplates = [];
    selectTemplateLabel = SendLetterConstants.SELECT_TEMPLATE_LABEL;
    communicationMechLabel = SendLetterConstants.COMMUNICATION_MECHANISM_LABEL;
    downloadRecipientsButtonLabel = SendLetterConstants.DOWNLOAD_RECIPIENTS_BTN_LABEL;
    downloadDocumentButtonLabel = SendLetterConstants.DOWNLOAD_DOCUMENTS_BTN_LABEL;
    attachmentManagerFormControl = SendLetterConstants.ATTACHMENT_MANAGER_CONTROL;
    commMechanismControl = SendLetterConstants.COMM_MECH_CONTROL;
    selectedTemplate;
    communicationMechanisms = LookupConstants.COMMUNICATION_MECHANISM;
    application;
    noRecipientErrMsg = SendLetterConstants.NO_RECIPIENT_ERR_MSG;
    headersForCsv = SendLetterConstants.HEADERS_FOR_CSV;
    noTemplateErrMsg = SendLetterConstants.NO_TEMPLATE_ERR_MSG;
    noCommMechSelectedErrMsg = SendLetterConstants.NO_COMM_MECHANISM_ERR_MSG;
    componentName = SendLetterConstants.COMPONENT_NAME;
    noAttachmentErrMsg = SendLetterConstants.NO_ATTACHMENT;
    sendLetterErrObj = SendLetterConstants.SEND_LETTER_ERR_OBJ;
    hideAttachmentManagerFilter = true;
    emailFieldTextPlaceholder = SendLetterConstants.EMAIL_FIELD_PLACEHOLDER;
    selectedApplicationSubscription;
    getTemplateAttachmentsSubscription;
    getLetterTemplatesSubscription;
    logExternalCommunicationSubscription;
    constructor(selectedApplicationService, sendLetterService, appControllerService, stepService, workflowJobService, currentStepService, changeDetectionRef) {
        this.selectedApplicationService = selectedApplicationService;
        this.sendLetterService = sendLetterService;
        this.appControllerService = appControllerService;
        this.stepService = stepService;
        this.workflowJobService = workflowJobService;
        this.currentStepService = currentStepService;
        this.changeDetectionRef = changeDetectionRef;
    }
    ngOnInit() {
        this.initialiseForm();
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((app) => {
            this.application = app;
        });
        this.getCommunications();
        this.getLetterTemplates();
        this.changeDetectionRef.detectChanges();
    }
    onDownloadDocumentsClicked() {
        const template = this.selectedTemplate;
        const communicationMechanism = this.sendLetterForm.get(this.commMechanismControl).value;
        if (template === null || template === undefined) {
            this.appControllerService.showMessage(this.noTemplateErrMsg, AlertType.Warning);
            return;
        }
        if (communicationMechanism === null || communicationMechanism === undefined) {
            this.appControllerService.showMessage(this.noCommMechSelectedErrMsg, AlertType.Warning);
            return;
        }
        if (this.communicationType === null || this.communicationType === undefined) {
            this.appControllerService.showMessage("Please select the communication type.", AlertType.Warning);
            return;
        }
        if (template.attachmentId === null || template.attachmentId === undefined) {
            this.appControllerService.showMessage(this.noAttachmentErrMsg, AlertType.Warning);
            return;
        }
        this.getTemplateAttachmentsSubscription =
            this.sendLetterService.getTemplateAttachments(template.id)
                .subscribe({
                next: (responseData) => {
                    FileUtils.openFile(template.attachment.fileName, responseData);
                    this.logCommunication();
                },
                error: (error) => {
                    this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
                }
            });
    }
    onDownloadRecipientsClicked() {
        if (this.recipients !== undefined) {
            if (this.recipients.length < 1) {
                this.appControllerService.showMessage(this.noRecipientErrMsg, AlertType.Warning);
                return;
            }
            const data = this.buildRecipientsData();
            const fileName = `${this.stepMeta.recipientFilter.label}s`;
            const options = {
                filename: fileName,
                fieldSeparator: ",",
                showLabels: true,
                useBom: true,
                headers: this.headersForCsv
            };
            // const csvExporter = new generateCsv(options);
            const csv = generateCsv(options)(data);
            download(options)(csv);
        }
        else {
            this.appControllerService.showMessage(this.noRecipientErrMsg, AlertType.Warning);
        }
    }
    getLetterTemplates() {
        this.getLetterTemplatesSubscription =
            this.sendLetterService.getLetterTemplates(this.stepName, this.moduleId)
                .subscribe({
                next: (responseData) => {
                    this.onGetLetterTemplatesCompleted(responseData);
                },
                error: (error) => {
                    this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
                }
            });
    }
    initialiseForm() {
        this.sendLetterForm = new FormGroup({
            communicationMechanism: new FormControl(null),
            attachmentManager: new FormControl(null)
        });
    }
    buildRecipientsData() {
        const data = [];
        this.recipients.forEach((recipient) => {
            data.push({
                selectedApplicationReferenceNumber: this.application.referenceNumber,
                name: recipient.name != null ? recipient.name : "",
                surname: recipient.surname != null ? recipient.surname : "",
                idNumber: recipient.idNumber != null ? recipient.idNumber : "",
                organisation: recipient.organisation != null ? recipient.organisation : "",
                designation: recipient.designation != null ? recipient.designation : "",
                telephone: recipient.telephone != null ? recipient.telephone : "",
                homephone: recipient.homePhone != null ? recipient.homePhone : "",
                cellphone: recipient.cellphone != null ? recipient.cellphone : "",
                fax: recipient.fax != null ? recipient.fax : "",
                email: recipient.email != null ? recipient.email : "",
                streetAddress: recipient.streetAddress != null ? recipient.streetAddress : "",
                streetSuburb: recipient.streetAddress != null ? recipient.streetAddress : "",
                streetCity: recipient.streetCity != null ? recipient.streetCity : "",
                streetProvince: recipient.streetProvince != null ? recipient.streetProvince : "",
                streetCode: recipient.streetCode != null ? recipient.streetCode : "",
                postalAddress: recipient.postalAddress != null ? recipient.postalAddress : "",
                postalSuburb: recipient.postalSuburb != null ? recipient.postalSuburb : "",
                postalCity: recipient.postalCity != null ? recipient.postalCity : "",
                postalProvince: recipient.postalProvince != null ? recipient.postalProvince : "",
                postalCode: recipient.postalCode != null ? recipient.postalCode : ""
            });
        });
        return data;
    }
    getCommunications() {
        this.communicationMechanisms = LookupConstants.COMMUNICATION_MECHANISM;
        this.communicationMechanisms.sort((a, b) => (a.localeCompare(b)));
        this.changeDetectionRef.detectChanges();
    }
    onGetLetterTemplatesCompleted(response) {
        const templatesArray = response.value;
        templatesArray.forEach((template) => {
            if (template.stepName === this.stepName) {
                if (template.type.toLowerCase() === "letter") {
                    this.letterTemplates.push(template);
                }
            }
            if (template.type.toLowerCase() === "both") {
                this.letterTemplates.push(template);
            }
        });
        this.letterTemplates.sort((a, b) => (a.name.localeCompare(b.name)));
        this.changeDetectionRef.detectChanges();
    }
    logCommunication() {
        const recipientsToUpdate = this.removeUnwantedProperties();
        const attachment = this.selectedTemplate.attachment !== null ? [this.selectedTemplate.attachment] : [];
        const template = this.selectedTemplate;
        const post = this.sendLetterForm.get(this.commMechanismControl).value;
        const communicationId = null;
        const commmunication = {
            communicationType: this.communicationType,
            jobId: +this.attachmentManagerJobId,
            communicationMechanism: post,
            direction: "Outgoing",
            relatedCommunicationId: communicationId,
            description: template.attachment.description,
            recipients: recipientsToUpdate,
            attachments: attachment,
            deleted: false
        };
        const step = this.currentStepService.currentStep;
        this.logExternalCommunicationSubscription =
            this.stepService.logExternalCommunication(commmunication, this.appControllerService.selectedJobID, step.name, step.id)
                .subscribe({
                next: () => {
                    this.letterSent.emit(true);
                },
                error: (error) => {
                    this.appControllerService.handleServerErrorMessage(this.sendLetterErrObj, error, CRUDOperation.Add);
                }
            });
    }
    removeUnwantedProperties() {
        const recipientsToUpdate = this.recipients;
        recipientsToUpdate.forEach((recipient) => {
            recipient = RecipientUtils.removeRecipientProperties(recipient);
        });
        return recipientsToUpdate;
    }
    static ctorParameters = () => [
        { type: SelectedApplicationService },
        { type: SendLetterService },
        { type: AppControllerService },
        { type: StepService },
        { type: WorkflowJobService },
        { type: CurrentStepService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        stepMeta: [{ type: Input }],
        recipients: [{ type: Input }],
        attachmentManagerAttachmentType: [{ type: Input }],
        attachmentManagerTitle: [{ type: Input }],
        attachmentManagerJobId: [{ type: Input }],
        communicationType: [{ type: Input }],
        moduleId: [{ type: Input }],
        stepName: [{ type: Input }],
        letterSent: [{ type: Output }]
    };
};
SendLetterComponent = __decorate([
    Component({
        selector: "app-send-letter",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SendLetterComponent);
export { SendLetterComponent };
